import React from 'react';
import { Grid2 as Grid } from '@mui/material';
import { useShowContext } from 'framework/show';
import { DashboardItemWithSections, DashboardCallbacks, DashboardMenuOption } from 'domain/shared/core/dashboard';
import { DISMISSED_STATUS } from 'domain/shared/employee';

interface EmployeeDashboardSectionProps {
  canEditDashboard: boolean;
  dashboardCallbacks: DashboardCallbacks;
}

const EmployeeDashboardSection: React.FC<EmployeeDashboardSectionProps> = ({
  canEditDashboard,
  dashboardCallbacks,
}) => {
  const { data: employee } = useShowContext();

  if (!canEditDashboard || employee.workingStatus === DISMISSED_STATUS) {
    return null;
  }

  return (
    <Grid size="grow" minWidth="630px">
      <DashboardItemWithSections
        item={{
          ...employee,
          id: employee?.getValueBySource('alias') || employee?.getValueBySource('id'),
        }}
        sectionsConfig={{
          issues: { enabled: canEditDashboard },
          followUps: { enabled: canEditDashboard },
          people: { enabled: canEditDashboard },
        }}
        menuOptions={
          canEditDashboard
            ? dashboardCallbacks.menuOptions.filter(option =>
                [
                  DashboardMenuOption.MANAGE_ISSUES,
                  DashboardMenuOption.ADD_FOLLOW_UP,
                  DashboardMenuOption.CHANGE_STAFFING_COORDINATOR,
                  DashboardMenuOption.CHANGE_ZONE,
                ].includes(option.key as DashboardMenuOption),
              )
            : undefined
        }
        onFollowUpRemove={dashboardCallbacks.handleFollowUpRemove}
        onFollowUpUpdate={dashboardCallbacks.handleFollowUpUpdate}
      />
    </Grid>
  );
};

export default EmployeeDashboardSection;
